var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38867 13.0508H8.61133C9.82422 13.0508 10.4277 12.4355 10.4277 11.2168V5.89648C10.4277 5.14062 10.3398 4.8125 9.87109 4.33203L6.64258 1.04492C6.19727 0.587891 5.82812 0.488281 5.17188 0.488281H2.38867C1.18164 0.488281 0.572266 1.10938 0.572266 2.32812V11.2168C0.572266 12.4414 1.17578 13.0508 2.38867 13.0508ZM2.42969 12.1074C1.82617 12.1074 1.51562 11.7852 1.51562 11.1992V2.3457C1.51562 1.76562 1.82617 1.43164 2.43555 1.43164H5.04297V4.83594C5.04297 5.57422 5.41211 5.9375 6.14453 5.9375H9.48438V11.1992C9.48438 11.7852 9.17383 12.1074 8.56445 12.1074H2.42969ZM6.25 5.05273C6.01562 5.05273 5.92773 4.95898 5.92773 4.72461V1.61328L9.30273 5.05273H6.25Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.4236de948f898bc4129e658b5fc33483.svg";
export { ForwardRef as ReactComponent };